import { z } from 'zod';
import {
  PAGINATION_PAGE_SIZE_DEFAULT,
  PAGINATION_SORT_DIRECTION,
} from '~/constants';

import { zodDlnSourceSchema } from '~/data/delivery/dlnSource';

import { PARSING_CASE_ORDER_BY } from '../orderBy';
import {
  zodParsingCaseBaseSchema,
  zodParsingCaseFailureCategorySchema,
  zodParsingCaseStatusSchema,
} from '../validations';

const zodPartyNameParamSchema = z
  .string()
  .trim()
  .transform((name) => name || undefined);

export const zodParsingCaseListItemSchema = zodParsingCaseBaseSchema;

export const zodPaginatedParsingCasesResponseSchema = z.object({
  data: z.array(zodParsingCaseListItemSchema),
  hasNextPage: z.boolean(),
  paginatedCount: z.number().int(),
  totalCount: z.number().int().nullish(),
});

export const parsingCaseListFilterParamSchemaFields = {
  accountingReferenceId: z.array(z.uuid()).optional(),
  buyerId: z.uuid().optional(),
  buyerName: zodPartyNameParamSchema.optional(),
  createdFrom: z.iso.datetime().optional(),
  createdTo: z.iso.datetime().optional(),
  failureCategory: z.array(zodParsingCaseFailureCategorySchema).optional(),
  includeDebatched: z.boolean().optional().prefault(false),
  includeSubsumed: z.boolean().optional().prefault(false),
  parserFormat: z.array(z.string()).optional(),
  searchString: z.string().trim().optional(),
  sellerId: z.uuid().optional(),
  sellerName: zodPartyNameParamSchema.optional(),
  shipFromId: z.uuid().optional(),
  shipToId: z.uuid().optional(),
  siteId: z.array(z.uuid()).optional(),
  source: z.array(zodDlnSourceSchema).optional(),
  status: z.array(zodParsingCaseStatusSchema).optional(),
  supplierId: z.uuid().optional(),
  technicalIssuerId: z.uuid().optional(),
} as const;

export const zodListParsingCasesParamsSchema = z.object({
  ...parsingCaseListFilterParamSchemaFields,
  limit: z
    .number()
    .int()
    .min(1)
    .max(500)
    .optional()
    .prefault(PAGINATION_PAGE_SIZE_DEFAULT),
  offset: z.number().int().nonnegative().optional().prefault(0),
  orderBy: z.enum(PARSING_CASE_ORDER_BY).optional().prefault('created_on'),
  returnTotalCount: z.boolean().optional().prefault(false),
  sortOrder: z.enum(PAGINATION_SORT_DIRECTION).optional().prefault('DESC'),
});

export { PARSING_CASE_ORDER_BY };
